import { Canceler } from 'axios';

import { GenericObject } from './generic-object';
import { UploadState, UploadType } from './enums';
import { copyFields } from './utils/copy-fields';
import { fixDates } from './utils/fix-dates';

export class Media {
    public id!: number;
    public pathname!: string;
    public originalName!: string;
    /** What the file is, in the user's words; shown instead of the file name. */
    public title?: string | null;
    public mimeType!: string;
    public size!: number;
    public type: UploadType = UploadType.Internal;
    public progress?: number;
    public state?: UploadState = UploadState.Finished;
    public cancel?: Canceler;
    public file?: File;
    public createdAt?: Date;
    public updatedAt?: Date;
    public documentId?: number;
    public contentBase64?: string;

    public static fromFile(file: File, type: UploadType = UploadType.Internal, contentBase64?: string): Media {
        return Media.fromPlainObject({
            id: -1,
            originalName: file.name,
            pathname: file.name,
            size: file.size,
            mimeType: '',
            state: UploadState.InProgress,
            type,
            file,
            documentId: -1,
            contentBase64,
        });
    }

    public static fromPlainObject(object: GenericObject): Media {
        const media = new Media();

        copyFields(object, media);

        fixDates(media, ['createdAt', 'updatedAt']);

        return media;
    }
}
